export default {
  // Nav
  "nav.home": "Accueil",
  "nav.woonlening": "Prêt hypothécaire",
  "nav.loa": "Prêts à tempérament",
  "nav.wieZijnWij": "Qui sommes-nous?",
  "nav.contact": "Contact",

  // Footer
  "footer.partners": "Partenaires",
  "footer.simuleer": "Simulez votre crédit",
  "footer.juridisch": "Mentions légales",
  "footer.privacy": "Confidentialité",
  "footer.hours": "Lun - Ven : 9h00 - 12h30 & 13h30 - 18h00",
  "footer.saturday": "Samedi après-midi sur rendez-vous",
  "footer.rights": "MADE BY TEKDAM. ALL RIGHTS RESERVED.",

  // Home - Hero
  "home.hero.title": "",
  "home.hero.body": " - Conseils de crédit de confiance depuis 1995",
  "home.hero.sub1": "Depuis trois décennies, particuliers et indépendants font confiance à Haskrediet pour des conseils de crédit experts et personnalisés.",
  "home.hero.sub1b": "Aujourd'hui, nous sommes prêts à réaliser vos projets également.",
  "home.hero.sub2": "Serez-vous le prochain ?",

  // Home - Simuleer
  "home.sim.title": "Simulez votre prêt",
  "home.sim.subtitle": "Calculez votre prêt en quelques clics",
  "home.sim.body": "Découvrez dès aujourd'hui vos possibilités financières. Avec la simulation en ligne de Haskrediet, vous calculez en quelques secondes combien vous pouvez emprunter et quel remboursement mensuel y correspond. Rapide, simple et entièrement sans engagement. Vous obtenez ainsi immédiatement un aperçu clair de votre budget et pouvez franchir la prochaine étape en toute confiance.",
  "home.sim.example": "Exemple:",
  "home.sim.exLine1": "Prêt à tempérament - Vous empruntez 8.000 € sur 48 mois",
  "home.sim.exLine2": "Mensualité: 183,86 € - Total à rembourser: 8.825,28 €",
  "home.sim.jkp": "TAEG:",
  "home.sim.rente": "Taux fixe ou variable:",

  // Simulation type toggle
  "sim.type.woon": "Prêt hypothécaire",
  "sim.type.loa": "Prêt à tempérament",

  // Home - Loan card
  "loan.personalLoan": "Prêt personnel",
  "loan.amount": "Montant",
  "loan.duration": "Durée (mois)",
  "loan.monthly": "Mensualité",
  "loan.months": "mois",
  "loan.personalCredit": "Crédit personnel",
  "loan.maxAmount": "Le montant maximum est de {max}.",
  "loan.totalRepay": "Total à rembourser",
  "loan.totalInterest": "Total des intérêts",
  "loan.chooseRateHint": "Choisissez un taux d'intérêt pour calculer votre simulation.",
  "loan.apply": "Demander",
  "loan.onlineApply": "Demande en ligne",

  // Contact form
  "contact.title": "Formulaire de contact",
  "contact.firstName": "Prénom",
  "contact.lastName": "Nom",
  "contact.email": "E-mail",
  "contact.phone": "Téléphone",
  "contact.send": "Envoyer",
  "contact.bubble": "Restons en contact",
  "contact.bubbleText": "Pour plus d'informations sur nos solutions de crédit, vous pouvez laisser vos coordonnées dans le formulaire. Nous vous contacterons dans les plus brefs délais.",
  "contact.message": "Votre message:",
  "contact.success": "Votre message a été envoyé avec succès!",
  "contact.error": "Une erreur s'est produite. Veuillez réessayer plus tard.",

  // Woonlening
  "woon.title": "PRÊT HYPOTHÉCAIRE",
  "woon.heroTitle": "Haskrediet - Votre partenaire fiable pour les crédits hypothécaires depuis 1995.",
  "woon.heroBody": "Vous rêvez de votre propre logement ?",
  "woon.heroText": "Avec plus de 30 ans d'expérience, Haskrediet vous guide vers le crédit hypothécaire parfaitement adapté à votre situation. Conseils indépendants, conditions avantageuses et accompagnement personnalisé de la demande à l'acte.",
  "woon.sim.title": "Simulez votre prêt hypothécaire",
  "woon.sim.subtitle": "Calculez votre mensualité",
  "woon.sim.years": "ans",
  "woon.startRequest": "Commencez votre demande",
  "woon.desiredAmount": "MONTANT SOUHAITÉ",
  "woon.slogan": "Votre rêve, notre engagement.",
  "woon.val1": "Acheter, rénover ou refinancer une maison? Chez {brand}, tout commence par l'écoute. Nous voulons comprendre ce qui compte vraiment pour vous: votre avenir, votre confort, votre rythme...",
  "woon.val2": "Nous ne croyons pas aux formules standards. Chaque prêt est unique, parce que chaque client l'est aussi. C'est pourquoi nous cherchons ensemble une solution adaptée à votre situation, aujourd'hui et demain.",
  "woon.val3": "Nos experts vous accompagnent avec des conseils clairs, des conditions honnêtes et une approche humaine.",
  "woon.val4": "Pas de promesses vides, mais des réponses claires et un véritable engagement.",
  "woon.cta": "Avec {brand}, vous faites vos choix en toute confiance: pas à pas, à votre rythme.",

  // Leningen
  "len.title": "PRÊTS À TEMPÉRAMENT",
  "len.heroLine1": "Vos projets méritent un financement sur mesure.",
  "len.heroText1": "Qu'il s'agisse d'une nouvelle voiture, d'une rénovation, d'un voyage de rêve ou de dépenses imprévues : chez nous, vous disposez rapidement de l'espace financier nécessaire. Nous examinons ensemble votre situation et recherchons une solution parfaitement adaptée à votre budget et à vos projets d'avenir. Transparent, personnel et sans surprises.",
  "len.heroTagline": "Vite réglé. Conditions claires. Accompagnement personnalisé.",
  "len.whatCanWeDo": "Que pouvons-nous faire pour vous?",
  "len.personal": "Prêt personnel",
  "len.personalDesc": "Un projet personnel, un achat important ou une dépense imprévue? Avec un prêt personnel chez Haskrediet, vous réalisez vos projets sans souci.",
  "len.auto": "Prêt auto",
  "len.autoDesc": "Vous cherchez une voiture neuve ou d'occasion? Avec notre prêt auto, vous roulez rapidement et à bon prix. Un financement compétitif à votre rythme.",
  "len.reno": "Prêt rénovation",
  "len.renoDesc": "Rénover ou rendre votre maison plus durable? Notre prêt rénovation donne une seconde vie à votre foyer - adapté à votre budget.",
  "len.regroup": "Regroupement de crédits",
  "len.regroupDesc": "Plusieurs prêts en cours? Nous les regroupons en une seule mensualité claire - souvent plus avantageuse, toujours plus lisible.",
  "len.chooseProject": "Choisissez votre projet",
  "len.desiredAmount": "Montant souhaité",
  "len.paymentCount": "Nombre de mensualités souhaitées?",
  "len.clickHere": "Cliquez ici",
  "len.dur": "Durée",
  "len.totalBack": "Total à rembourser:",

  // Broker info
  "home.broker.title": "Pourquoi choisir Haskrediet ?",
  "home.broker.intro1": "Depuis 1995, Haskrediet accompagne ses clients dans la recherche de la solution de crédit idéale. Grâce à plus de 30 ans d'expérience, nous avons bâti une solide réputation en tant que courtier en crédit fiable et professionnel.",
  "home.broker.intro2": "",
  "home.broker.troeven": "Nos atouts",
  "home.broker.ervaring.title": "Une grande expérience et expertise",
  "home.broker.ervaring.text": "Depuis 1995, nous suivons le marché du crédit de près. Cela nous permet de conseiller et d'accompagner nos clients de manière experte lors de décisions financières importantes.",
  "home.broker.persoonlijk.title": "Une approche personnalisée",
  "home.broker.persoonlijk.text": "Nous écoutons vos souhaits, analysons votre situation et recherchons une solution parfaitement adaptée à vos besoins.",
  "home.broker.onafhankelijk.title": "Des conseils indépendants",
  "home.broker.onafhankelijk.text": "En tant que courtier en crédit, nous comparons différents prêteurs. Nous vous aidons ainsi à trouver une formule avec les conditions les plus adaptées à votre profil.",
  "home.broker.begeleiding.title": "Un accompagnement complet",
  "home.broker.begeleiding.text": "De la première demande au traitement final de votre dossier, nous sommes à vos côtés. Vous pouvez compter sur une communication claire et un soutien professionnel tout au long du processus.",
  "home.broker.vertrouwen.title": "Confiance et transparence",
  "home.broker.vertrouwen.text": "Depuis plus de trois décennies, les clients choisissent Haskrediet pour notre approche honnête, nos informations transparentes et notre service fiable.",
  "home.broker.aanbod.title": "Large gamme",
  "home.broker.aanbod.text": "Des prêts hypothécaires et crédits personnels au leasing et crédits professionnels: chez Haskrediet, vous trouverez toutes les solutions de financement sous un même toit.",
  "home.broker.closing.title": "Plus de 30 ans d'expérience à votre avantage",
  "home.broker.closing.text": "Chez Haskrediet, nous croyons qu'un bon conseil en crédit commence par l'écoute du client. C'est pourquoi nous nous engageons chaque jour à offrir des solutions financières sur mesure, soutenues par l'expérience, l'expertise et un service personnalisé.",
  "home.broker.closing.tagline": "Haskrediet - votre partenaire de crédit de confiance depuis 1995.",

  // Simulation info
  "home.sim.free": "Démarrez votre simulation gratuite - c'est entièrement sans engagement et sans obligation.",

  // Loan calculator
  "loan.rate": "Taux d'intérêt annuel (%)",
  "loan.amountInfo.woon": "Le montant souhaité pour un prêt hypothécaire se situe entre 25.000 € et 3.000.000 €.",
  "loan.amountInfo.loa": "Le montant souhaité pour un prêt à tempérament se situe entre 500 € et 99.999,99 €.",
  "loan.durationInfo.woon": "La durée d'un prêt hypothécaire est comprise entre 5 et 30 ans.",
  "loan.durationInfo.loa": "La durée dépend du montant emprunté :",
  "loan.durationTable.amount": "Montant",
  "loan.durationTable.maxDuration": "Durée max.",
  "loan.durationTable.above": "Au-delà",
  "loan.rateInfo": "Vous choisissez ici vous-même un taux d'intérêt pour votre simulation. Ce n'est pas le taux définitif. Le pourcentage réel dépend de différents facteurs et sera déterminé après un conseil personnalisé de HASKREDIET.",

  // Footer
  "footer.maps": "ITINÉRAIRE",

  // Verzekeringen
  "nav.verzekeringen": "Assurances",
  "verz.title": "ASSURANCES",
  "verz.intro": "En plus des solutions de crédit, nous proposons également une large gamme d'assurances. Découvrez notre offre complète sur notre page assurances.",
  "verz.link": "Vers Haskrediet Assurances",

  // Leasing
  "nav.leasing": "Leasing",
  "leasing.title": "DEMANDE DE LEASING",
  "leasing.heroTitle": "Investissez aujourd'hui, payez de manière échelonnée",
  "leasing.heroText": "Vous souhaitez financer un véhicule, une camionnette, une machine ou du matériel professionnel sans toucher à votre capital disponible ? Avec le leasing via Haskrediet, vous bénéficiez d'une solution flexible et fiscalement intéressante, entièrement adaptée à votre entreprise.",
  "leasing.whyTitle": "Pourquoi choisir le leasing via Haskrediet ?",
  "leasing.why1": "Traitement rapide et personnalisé de votre dossier",
  "leasing.why2": "Financement sur mesure pour votre entreprise",
  "leasing.why3": "Préservation de votre fonds de roulement et de votre marge financière",
  "leasing.why4": "Possibilité d'achat en fin de contrat",
  "leasing.why5": "Conditions transparentes, sans surprises",
  "leasing.why6": "Plus de 30 ans d'expérience en solutions financières",
  "leasing.whatTitle": "Pour quels investissements ?",
  "leasing.whatIntro": "Nous vous accompagnons dans le leasing de :",
  "leasing.what1": "Voitures particulières et véhicules de société",
  "leasing.what2": "Camionnettes et camions",
  "leasing.what3": "Machines et matériel de production",
  "leasing.what4": "Matériel de construction et agricole",
  "leasing.what5": "Équipement informatique et de bureau",
  "leasing.what6": "Équipement médical et professionnel",
  "leasing.customTitle": "Une solution adaptée à votre activité",
  "leasing.customText": "Chaque entreprise est unique. C'est pourquoi nous examinons ensemble quelle formule de leasing correspond le mieux à vos besoins, votre budget et vos plans de croissance.",
  "leasing.customTagline": "Rapide, expert et accompagnement personnalisé.",
  "leasing.ctaTitle": "Demandez votre leasing sans engagement",
  "leasing.ctaText": "Vous souhaitez connaître les possibilités pour votre investissement ? Nos spécialistes sont prêts à vous conseiller et à élaborer une proposition sur mesure.",
  "leasing.ctaClosing": "Demandez votre leasing dès aujourd'hui et réalisez vos projets professionnels en toute confiance.",
  "leasing.ctaTagline": "Haskrediet - Votre partenaire fiable en financement depuis 1995.",
  "leasing.contactBtn": "Contactez-nous",
  "leasing.formSubject": "Nouvelle demande de leasing - Haskrediet",

  // Ondernemers
  "nav.ondernemers": "Entrepreneurs",
  "ond.title": "CRÉDITS PROFESSIONNELS & D'INVESTISSEMENT",
  "ond.heroTitle": "Donnez à votre entreprise l'espace pour grandir",
  "ond.heroText1": "Vous souhaitez investir dans l'avenir de votre entreprise ? Avec un crédit professionnel ou d'investissement via Haskrediet, vous disposez des moyens financiers pour réaliser vos projets, sans mettre en danger votre liquidité.",
  "ond.heroText2": "Que vous démarriez, vous développiez ou modernisiez, nous vous accompagnons avec une solution de financement adaptée aux ambitions de votre entreprise.",
  "ond.whatTitle": "À quoi peut servir un crédit d'investissement ?",
  "ond.what1": "Achat ou rénovation de bâtiments professionnels",
  "ond.what2": "Machines et matériel de production",
  "ond.what3": "Véhicules et voitures de société",
  "ond.what4": "Infrastructure IT et digitalisation",
  "ond.what5": "Extension de vos activités",
  "ond.what6": "Reprise d'un fonds de commerce",
  "ond.what7": "Financement de matériel professionnel",
  "ond.what8": "Renforcement de votre fonds de roulement",
  "ond.whyTitle": "Pourquoi choisir Haskrediet ?",
  "ond.adv1.title": "Conseils personnalisés sur mesure",
  "ond.adv1.text": "Chaque entreprise est unique. C'est pourquoi nous recherchons ensemble la solution de financement qui correspond à votre activité et vos projets d'avenir.",
  "ond.adv2.title": "Plus de 30 ans d'expérience",
  "ond.adv2.text": "Depuis 1995, nous accompagnons les indépendants, professions libérales, PME et entrepreneurs avec des conseils experts et indépendants.",
  "ond.adv3.title": "Traitement rapide et efficace",
  "ond.adv3.text": "Nous analysons votre dossier avec soin et assurons un suivi fluide, pour que vous puissiez vous concentrer sur votre entreprise.",
  "ond.adv4.title": "Conditions transparentes",
  "ond.adv4.text": "Des accords clairs et un financement adapté à vos possibilités et objectifs.",
  "ond.closingTitle": "Investissez en confiance. Grandissez en sécurité.",
  "ond.closingText": "Une entreprise solide mérite un partenaire financier solide. Haskrediet vous aide à réaliser vos projets d'investissement avec des conseils professionnels et des solutions sur mesure.",
  "ond.closingCta": "Demandez dès aujourd'hui votre crédit professionnel ou d'investissement sans engagement.",
  "ond.closingTagline": "Haskrediet - Votre partenaire fiable pour les entrepreneurs et indépendants depuis plus de 30 ans.",
  "ond.contactBtn": "Contactez-nous",
  "ond.formSubject": "Nouvelle demande crédit professionnel - Haskrediet",

  // Wie zijn wij
  "wie.title": "QUI SOMMES-NOUS?",
  "wie.heroIntro1": "En tant que courtier en crédit, nous accompagnons les particuliers et les entrepreneurs dans la recherche de la solution de financement la plus adaptée. Grâce à notre position indépendante, nous comparons différents prêteurs et recherchons une formule qui correspond à votre situation financière, vos souhaits et vos projets d'avenir.",
  "wie.heroIntro2": "Nous croyons qu'un crédit est bien plus qu'un simple prêt. C'est une décision financière importante qui nécessite des conseils experts, de la transparence et un accompagnement personnalisé. C'est pourquoi nous prenons le temps d'analyser votre dossier en profondeur et de vous expliquer clairement toutes les possibilités.",
  "wie.heroIntro3": "Qu'il s'agisse d'un crédit hypothécaire, d'un refinancement, d'un crédit d'investissement ou d'un autre besoin de financement, nous vous accompagnons tout au long du parcours : de la première simulation à la signature finale.",
  "wie.values.title": "Nos valeurs fondamentales :",
  "wie.values.onafhankelijk": "Conseils indépendants : nous comparons différents prestataires pour trouver la meilleure solution pour vous.",
  "wie.values.begeleiding": "Accompagnement personnalisé : chaque client et chaque dossier est unique.",
  "wie.values.transparantie": "Transparence : une communication claire, sans surprises.",
  "wie.values.deskundigheid": "Expertise : une connaissance actuelle du marché du crédit et de la réglementation financière.",
  "wie.closing1": "En tant que courtier en crédit, nous nous efforçons de rendre le financement accessible, compréhensible et sans souci. Ainsi, vous pouvez faire les bons choix financiers en toute confiance.",
  "wie.closing2": "Courtier en crédit - votre partenaire fiable pour des conseils de crédit sur mesure.",

  // Juridische mededeling
  "jur.title": "MENTIONS LEGALES",
  "jur.companyTitle": "Coordonnées de l'entreprise",
  "jur.btwLabel": "TVA",
  "jur.activityTitle": "Activité",
  "jur.activityText": "HASKREDIET BV est actif en tant qu'intermédiaire en crédit hypothécaire et en crédit à la consommation. Nous agissons comme courtier en crédit et comparons les offres de différents prêteurs afin de trouver la solution de financement la plus adaptée pour nos clients.",
  "jur.fsmaTitle": "Autorité de contrôle",
  "jur.fsmaText": "HASKREDIET BV est inscrit comme intermédiaire en crédit hypothécaire et en crédit à la consommation auprès de la FSMA (Autorité des Services et Marchés Financiers), Rue du Congrès 12-14, 1000 Bruxelles.",
  "jur.fsmaCheck": "Vous pouvez vérifier notre inscription sur le site de la FSMA: www.fsma.be.",
  "jur.disclaimerTitle": "Avertissement",
  "jur.disclaimerText1": "Les informations présentes sur ce site sont purement informatives et ne constituent pas une offre de crédit. Chaque demande de crédit est évaluée individuellement et est soumise à l'approbation du prêteur.",
  "jur.disclaimerText2": "Les simulations sur ce site sont indicatives et non contraignantes. Les conditions réelles peuvent varier après analyse de votre situation personnelle.",
  "jur.liabilityTitle": "Responsabilité",
  "jur.liabilityText1": "HASKREDIET BV apporte le plus grand soin au contenu de ce site, mais ne peut garantir l'exhaustivité, l'exactitude ou l'actualité des informations fournies.",
  "jur.liabilityText2": "HASKREDIET BV ne peut être tenu responsable d'éventuels dommages résultant de l'utilisation de ce site ou des informations qui y sont présentées.",
  "jur.ipTitle": "Propriété intellectuelle",
  "jur.ipText": "Tous les textes, images, logos et autres éléments de ce site sont protégés par le droit d'auteur et ne peuvent être reproduits, distribués ou utilisés sans l'autorisation écrite préalable de HASKREDIET BV.",
  "jur.disputeTitle": "Litiges",
  "jur.disputeText": "Les présentes mentions légales et l'utilisation de ce site sont régies par le droit belge. Tout litige relève de la compétence exclusive des tribunaux de Gand.",

  // Privacy
  "priv.title": "POLITIQUE DE CONFIDENTIALITE",
  "priv.intro": "HASKREDIET BV attache une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique quelles données nous collectons, pourquoi nous le faisons et comment nous protégeons votre vie privée, conformément au Règlement Général sur la Protection des Données (RGPD).",
  "priv.controllerTitle": "Responsable du traitement",
  "priv.dataTitle": "Quelles données collectons-nous?",
  "priv.dataText": "Nous pouvons collecter les données personnelles suivantes lorsque vous nous contactez ou soumettez une demande:",
  "priv.data1": "Nom et prénom",
  "priv.data2": "Adresse e-mail",
  "priv.data3": "Numéro de téléphone",
  "priv.data4": "Messages envoyés via le formulaire de contact",
  "priv.purposeTitle": "A quoi servent vos données?",
  "priv.purposeText": "Vos données personnelles sont exclusivement utilisées aux fins suivantes:",
  "priv.purpose1": "Répondre à vos questions et demandes",
  "priv.purpose2": "Fournir des conseils sur les solutions de crédit et de financement",
  "priv.purpose3": "Assurer le suivi de votre dossier",
  "priv.legalTitle": "Base juridique",
  "priv.legalText": "Le traitement de vos données personnelles est basé sur votre consentement (lors du remplissage du formulaire de contact) et sur l'exécution d'un contrat ou de mesures précontractuelles.",
  "priv.retentionTitle": "Durée de conservation",
  "priv.retentionText": "Vos données personnelles ne sont pas conservées plus longtemps que nécessaire aux fins pour lesquelles elles ont été collectées, sauf si une durée de conservation plus longue est légalement requise.",
  "priv.sharingTitle": "Partage des données",
  "priv.sharingText": "Nous ne partageons pas vos données personnelles avec des tiers, sauf si cela est nécessaire à l'exécution de nos services (par exemple avec un prêteur dans le cadre d'une demande de crédit) ou lorsque nous y sommes légalement obligés.",
  "priv.rightsTitle": "Vos droits",
  "priv.rightsText": "Vous avez à tout moment le droit de:",
  "priv.right1": "Consulter vos données personnelles",
  "priv.right2": "Faire corriger ou compléter vos données",
  "priv.right3": "Faire supprimer vos données",
  "priv.right4": "Limiter le traitement de vos données",
  "priv.right5": "Vous opposer au traitement de vos données",
  "priv.rightsContact": "Vous pouvez exercer vos droits en nous contactant à info@haskrediet.be ou au 09/267.30.30.",
  "priv.cookieTitle": "Cookies",
  "priv.cookieText": "Ce site peut utiliser des cookies pour améliorer l'expérience utilisateur. En continuant à utiliser le site, vous acceptez l'utilisation de cookies.",
  "priv.changeTitle": "Modifications",
  "priv.changeText": "HASKREDIET BV se réserve le droit de modifier cette politique de confidentialité à tout moment. La version la plus récente est toujours disponible sur cette page.",

  // Disclaimer
  "loan.disclaimer": "Prêt sous réserve d'acceptation du dossier",

  // Global
  "global.loanCost": "Attention, emprunter de l'argent coûte aussi de l'argent.",
} as Record<string, string>;
